var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "0.7em",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48784 2.58593L2.6174 9.48826C2.49624 9.60941 2.49625 9.80735 2.61802 9.92912L3.85011 11.1612C3.97188 11.283 4.16985 11.283 4.29162 11.1612L4.69567 10.7578L6.6384 12.7006C7.89421 13.9564 9.88068 14.0188 11.2283 12.9191L13.2178 14.9087C13.3396 15.0304 13.5376 15.0304 13.6593 14.9087L14.9083 13.6597C14.9695 13.5985 14.9995 13.5186 14.9995 13.4387C14.9995 13.3587 14.9689 13.2788 14.9083 13.2176L12.9187 11.228C13.432 10.5985 13.7049 9.83668 13.7049 9.06671C13.7049 8.18746 13.3702 7.30757 12.7008 6.63814L10.7581 4.6954L11.1615 4.292C11.282 4.17149 11.2832 3.9754 11.1646 3.85362L9.93249 2.58845C9.8738 2.5285 9.79386 2.49478 9.71081 2.49417C9.62774 2.49352 9.54654 2.52724 9.48784 2.58593Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.349161 4.09982C-0.116062 4.56442 -0.116062 5.3219 0.349161 5.78651L2.89078 8.32812L4.57747 6.63394L2.0396 4.09671C1.81417 3.87129 1.51504 3.747 1.19595 3.747C0.87685 3.747 0.577718 3.87126 0.349161 4.09982Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09599 0.353688C3.63076 0.818296 3.63076 1.57577 4.09599 2.04038L6.62885 4.57324L8.31553 2.87841L5.78704 0.349912C5.56161 0.124487 5.26248 0.000197344 4.94339 0.000197358C4.62429 0.000197372 4.32454 0.124487 4.09599 0.353688Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 15) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.e3c2872af87ef78ac1534ce0caac6516.svg";
export { ForwardRef as ReactComponent };